  import { Button } from "react-bootstrap";
import { showAddAccountAlertNew } from "../../../../../../utils";
import { FontAwesomeIcon } from "../../../../../CommonComponents/AssetsHelper";

const ConnectedAccountButton = ({ class_name, title,item }) => {
  
  const reconnectAccount = () => {
    localStorage.setItem('refresh',1);
    const connectiontype = window.location.pathname.includes('connection') ? 'connectAccount':'socialConnect';
    showAddAccountAlertNew(item.Network,connectiontype);
  };

  return (
    <Button className={class_name} onClick={() => reconnectAccount()}>
        <FontAwesomeIcon type={'regular'} icon={'arrows-rotate'} iconClass={'text-white fs-6 me-1'} /> {title}
    </Button>
  );
};


  
export default ConnectedAccountButton;
